import core from '~/core/scripts';
import LegacyApp from './legacy-app';

import './index.styl';

if (module.hot) {
  // we only want HMR enabled for stylus files
  module.hot.accept(/\.styl$/);
}

core.init();
LegacyApp.init();
